module.exports = __webpack_public_path__ + "images/cm-blog-banner-visuals-4.png";